@if (show) {
  <div class="env-border" [attr.hide]="hide">
    <div [ngStyle]="{ 'box-shadow': '0 0 0 20px ' + envColor }">
      <h4 [ngStyle]="{ 'background-color': envColor }">
        {{ environment.target }}
      </h4>
    </div>
  </div>
}
